import React from 'react';
import queryString from 'query-string';
import { useHistory, useLocation } from 'react-router-dom';
import { locationToOpenModal } from '#app/containers/routes';

export function useLocationParts() {
  const location = useLocation();
  const pathParts = (location?.pathname || '').split('/');
  const queryParts = queryString.parse(location?.search) || {};

  return {
    pathParts,
    queryParts,
  };
}

export function useRedirect() {
  const location = useLocation();
  const history = useHistory();

  return React.useCallback(
    (pathname, searchData) =>
      history.push({
        ...location,
        pathname,
        search: queryString.stringify({
          ...searchData,
        }),
      }),
    [history, location],
  );
}

export function useKycRedirect() {
  const redirect = useRedirect();
  return React.useCallback(
    (kycStatus) =>
      redirect('/verification', {
        kyc: kycStatus,
      }),
    [redirect],
  );
}

export function usePasswordResetRedirect() {
  const redirect = useRedirect();
  return React.useCallback(
    (username) =>
      redirect('/password-reset', {
        username,
      }),
    [redirect],
  );
}

export function useOpenModal() {
  const location = useLocation();
  const history = useHistory();

  return React.useCallback(
    ({ modalName, params = {} }) =>
      history.push(
        locationToOpenModal(location, modalName, null, {
          ...params,
        }),
      ),
    [history, location],
  );
}
